// Inline stroke icons, exactly as specified in the design (§4). Decorative by
// default (aria-hidden); icon-only buttons carry their own aria-label.

const PATHS = {
  logo: (
    <>
      <circle cx="6" cy="6" r="2.6" />
      <circle cx="14" cy="14" r="2.6" />
      <path d="M7.9 7.9l4.2 4.2" />
      <circle cx="14" cy="6" r="1.4" />
      <circle cx="6" cy="14" r="1.4" />
    </>
  ),
  'logo-mini': (
    <>
      <circle cx="6" cy="6" r="2.6" />
      <circle cx="14" cy="14" r="2.6" />
      <path d="M7.9 7.9l4.2 4.2" />
    </>
  ),
  ticket: (
    <>
      <path d="M2.5 5.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1V7a1.2 1.2 0 0 0 0 2v1.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V9a1.2 1.2 0 0 0 0-2z" />
      <path d="M10 4.8v1.2M10 7.4v1.2M10 10v1.2" />
    </>
  ),
  save: (
    <>
      <path d="M3 3.5a.5.5 0 0 1 .5-.5h7.3l2.2 2.2v7.3a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
      <path d="M5.5 3v3h4.5V3M5.5 13v-3.5h5V13" />
    </>
  ),
  plus: <path d="M8 3.5v9M3.5 8h9" />,
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5 14 14" />
    </>
  ),
  layers: (
    <>
      <path d="M8 2 2 5l6 3 6-3-6-3z" />
      <path d="M2 8l6 3 6-3" />
      <path d="M2 11l6 3 6-3" />
    </>
  ),
  sliders: (
    <>
      <path d="M2.5 5h11M2.5 11h11" />
      <circle cx="6" cy="5" r="1.8" fill="#EEEBE4" />
      <circle cx="10.5" cy="11" r="1.8" fill="#EEEBE4" />
    </>
  ),
  share: (
    <>
      <path d="M8 10V2.5M5 5.5l3-3 3 3" />
      <path d="M3 9v4.5h10V9" />
    </>
  ),
  copy: (
    <>
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.6" />
      <path d="M3 10.5V3h7.5" />
    </>
  ),
  open: (
    <>
      <path d="M9.5 2.5h4v4" />
      <path d="M13.5 2.5 7.5 8.5" />
      <path d="M11.5 9.5v4h-9v-9h4" />
    </>
  ),
  'chevron-down': <path d="M4 6l4 4 4-4" />,
  warning: (
    <>
      <path d="M8 2.3 14.2 13.2H1.8z" />
      <path d="M8 6.5v3.2" />
      <path d="M8 11.6v.2" />
    </>
  ),
  file: (
    <>
      <path d="M4 1.8h5.2L12.5 5v9.2H4z" />
      <path d="M9 2v3.2h3.3" />
    </>
  ),
  braces: (
    <>
      <path d="M5.5 3C4 3 4 4 4 5v1.5C4 7.3 3.3 8 2.5 8c.8 0 1.5.7 1.5 1.5V11c0 1 0 2 1.5 2" />
      <path d="M10.5 3c1.5 0 1.5 1 1.5 2v1.5c0 .8.7 1.5 1.5 1.5-.8 0-1.5.7-1.5 1.5V11c0 1 0 2-1.5 2" />
    </>
  ),
  'thumb-up': (
    <>
      <path d="M5 7.2v6.3H2.8V7.2z" />
      <path d="M5 7.2 7.8 2.5c.9 0 1.6.7 1.6 1.6v2.2h3.4c.8 0 1.4.8 1.2 1.6l-1.1 4.4c-.2.7-.8 1.2-1.5 1.2H5" />
    </>
  ),
  'thumb-down': (
    <g transform="rotate(180 8 8)">
      <path d="M5 7.2v6.3H2.8V7.2z" />
      <path d="M5 7.2 7.8 2.5c.9 0 1.6.7 1.6 1.6v2.2h3.4c.8 0 1.4.8 1.2 1.6l-1.1 4.4c-.2.7-.8 1.2-1.5 1.2H5" />
    </g>
  ),
  'arrow-up': <path d="M8 13V3.5M4 7.5l4-4 4 4" />,
  'arrow-right': <path d="M3 8h10M9 4l4 4-4 4" />,
  swap: (
    <>
      <path d="M2.5 5.5h11M10.5 2.5l3 3-3 3" />
      <path d="M13.5 10.5h-11M5.5 7.5l-3 3 3 3" />
    </>
  ),
  return: (
    <>
      <path d="M13 4v3.5a2 2 0 0 1-2 2H3.5" />
      <path d="M6 6.5l-3 3 3 3" />
    </>
  ),
  check: <path d="M3 8.5l3.2 3.2L13 4.8" />,
  info: (
    <>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 7.3v3.7M8 5.1v.1" />
    </>
  ),
  edit: <path d="M10.8 2.7l2.5 2.5L6 12.5l-3.2.7.7-3.2z" />,
  // App additions (states the static design does not show).
  stop: <rect x="4.5" y="4.5" width="7" height="7" rx="1.5" fill="currentColor" />,
  close: <path d="M4 4l8 8M12 4l-8 8" />,
  trash: (
    <>
      <path d="M3 4.5h10M6.5 4.5V3h3v1.5" />
      <path d="M4.5 4.5l.6 9h5.8l.6-9" />
    </>
  ),
  refresh: (
    <>
      <path d="M13 8a5 5 0 1 1-1.5-3.6" />
      <path d="M13 2.5v3h-3" />
    </>
  ),
  link: (
    <>
      <path d="M6.8 9.2a2.6 2.6 0 0 0 3.7 0l2.2-2.2a2.6 2.6 0 0 0-3.7-3.7l-.6.6" />
      <path d="M9.2 6.8a2.6 2.6 0 0 0-3.7 0L3.3 9a2.6 2.6 0 0 0 3.7 3.7l.6-.6" />
    </>
  ),
}

export function Icon({ name, size = 16, strokeWidth = 1.6, stroke, className, style, viewBox }) {
  const isDots = name === 'dots'
  const box = viewBox ?? (name === 'logo' || name === 'logo-mini' ? '0 0 20 20' : '0 0 16 16')
  if (isDots) {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" className={className} style={style}>
        <circle cx="3.5" cy="8" r="1.3" />
        <circle cx="8" cy="8" r="1.3" />
        <circle cx="12.5" cy="8" r="1.3" />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={box}
      fill="none"
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={style}
    >
      {PATHS[name] ?? null}
    </svg>
  )
}
